import { Component, DefaultIterableDiffer, Inject, Injectable, Injector } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
// import { ToastrService, GlobalConfig } from 'ngx-toastr';
// import { th } from 'date-fns/locale';
// import { NgxSpinnerService } from 'ngx-spinner';
// import { Globals } from 'src/app/app.globals';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { LoginResponseModel } from 'src/app/core/models/security/auth/login-response.model';
// import { ToastrHelperService } from './toastr-helper.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';

import { PrimeNGConfig } from 'primeng/api';
import { LocalStorageService } from './local-storage.service';
import { ServiceResponseModel } from '../models/general/service-response.model';
import { SweetAlertService } from './sweet-alert.service';

declare let $: any
@Injectable({
  providedIn: 'root'
})

@Injectable({ providedIn: 'root' })
export class HttpService {
  API_URL = `${environment.apiUrl}`;

  // options: GlobalConfig;
  loginResponse: LoginResponseModel = new LoginResponseModel;
  appToken: string = "";
  language: string = "tr";
  constructor(
    private http: HttpClient,
    private injector: Injector,
    private router: Router,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    // private messageHelper: MessageHelper,
    // private toastrHelper : ToastrHelperService,
    // public toastrService: ToastrService,
    // private spinner: NgxSpinnerService
  ) {
    this.primengConfig.ripple = true;

    // this.options = this.toastrService.toastrConfig;
    //this.options.positionClass = 'toast-bottom-full-width';
    // this.options.positionClass = 'toast-top-right';
  }
  // Need to get ToastrService from injector rather than constructor injection to avoid cyclic dependency error
  // private get toastrService(): ToastrService {
  //   return this.injector.get(ToastrService);
  // }
  //  spinnerCount:number=0;
  /**
   * @param options.hataToastGoster
   *   Varsayılan true: iş hatası sağ üstte PrimeNG toast'ı olarak gösterilir
   *   (tek kaynak kuralı, aşağıdaki tap bloğuna bakınız).
   *
   *   false verildiğinde toast BASTIRILIR; hatayı çağıran gösterir. Bunu yalnızca
   *   çağıranın daha iyi bir mesaj kurabildiği yerlerde kullanın — örneğin patent
   *   firma ataması, hangi patentin reddedildiğini ekranın ortasında söyleyebiliyor.
   *   Observable yine hata ile sonlanır, yani hata SESSİZE ALINMAZ; sadece nerede
   *   gösterileceği değişir.
   */
  Post<T>(
    ApiControllerAction: string,
    request: any,
    options?: { hataToastGoster?: boolean }
  ): Observable<ServiceResponseModel> {
    const hataToastGoster = options?.hataToastGoster !== false;
    // this.spinner.show();
    // this.spinnerCount+=1


    // Auth header'ları AuthInterceptor tarafından eklenmektedir (F6)
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Accept': 'application/json' }) };

    return this.http.post<ServiceResponseModel>(this.API_URL + ApiControllerAction, request, httpOptions)
      .pipe(
        catchError(err => {

          return this.errorHandler(err)
        }),
        tap(x => {
          this.spinner.hide();
          // Success Messages
          if (x.messageType === "error") {
            
            // this.messageService.add({ key: 'tr', severity: x.messageType, summary: x.AppException.messageHeader, detail: x.AppException.appMessage });
            // Hata bildirimi tek kaynak: component'ler ayrıca hata kutusu açmıyor.
            // Varsayılan 3 sn kısa kaldığı için ömür uzatılıp kapatma butonu veriliyor.
            // İSTİSNA: hataToastGoster=false ise gösterim çağırana devredilmiştir.
            if (hataToastGoster) {
              this.messageService.add({ key: 'tr', severity: x.messageType, summary: x.messageHeader, detail: x.message, life: 8000, closable: true });
            }
            if (x.AppException?.code === 501) {
              setTimeout(() => {
                LocalStorageService.delEncodedLocalStorageItem();
                window.location.href = `${environment.loginUrl}`;
              }, 2000);
            }
            // Firma kullanıcısı normal login ekranından girmeye çalıştı → firma login'e yönlendir
            if (x.AppException?.code === 405) {
              setTimeout(() => {
                LocalStorageService.delEncodedLocalStorageItem();
                window.location.href = `${environment.loginUrlFirma}`;
              }, 2000);
            }
          }
          if (x.messageType === "success") {

            this.messageService.add({ key: 'tr', severity: x.messageType, summary: x.messageHeader, detail: x.message });
            // setTimeout(() => {
            //   window.location.href=`${environment.loginUrl}`;
            // }, 1000);
          }

          if (x.messageType === "warning") {

            this.messageService.add({ key: 'tr', severity: x.messageType, summary: x.messageHeader, detail: x.message });
            // setTimeout(() => {
            //   window.location.href=`${environment.loginUrl}`;
            // }, 1000);
          }

        }),
        map(x => {
          // Sunucu "error" döndürdüğünde Observable'ı hata olarak sonlandır.
          // Bu olmadan downstream map/next çalışmaya devam eder ve component yanlışlıkla
          // "Başarılı" mesajı gösterir.
          if (x.messageType === "error") {
            throw new Error(x.message || x.messageHeader || 'Bir hata oluştu.');
          }
          return x;
        })
        // retry(3)
        //retry 2 times on error

      );
  }

  /**
   * Blob (dosya) indirmek için POST isteği
   * Response ile birlikte dosya adını da döndürür
   * @param ApiControllerAction API endpoint
   * @param request İstek body'si
   * @returns Observable<{blob: Blob, fileName: string}>
   */
  PostBlob(ApiControllerAction: string, request: any): Observable<{blob: Blob, fileName: string}> {
    // Auth header'ları AuthInterceptor tarafından eklenmektedir (F6)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/pdf'
      }),
      responseType: 'blob' as 'json',
      observe: 'response' as 'response'
    };

    return this.http.post<Blob>(this.API_URL + ApiControllerAction, request, httpOptions)
      .pipe(
        map((response: any) => {
          // x-file-name header'ından dosya adını al
          let fileName = response.headers.get('x-file-name') || 'download.pdf';
          
          // URL encoded ise decode et
          try {
            fileName = decodeURIComponent(fileName);
          } catch (e) {
            // decode başarısız olursa orijinal değeri kullan
          }
          
          return {
            blob: response.body as Blob,
            fileName: fileName
          };
        }),
        catchError(err => {
          return this.errorHandler(err);
        })
      );
  }

  private errorHandler(error: HttpErrorResponse) {
    //volkan
    // TODO login bilgisi hatası neyse ona göre düzelt bunun koduda vardır ae
    if (error.error === "Login bilginiz artık geçersiz. Lütfen yeniden giriş yapınız.") {
      this.messageService.add({ key: 'tr', severity: 'error', summary: 'Security Error', detail: error.error + ' Login sayfasına yönlendiriliyorsunuz' });
       LocalStorageService.delEncodedLocalStorageItem();
       this.router.navigate(['/']);
       setTimeout(() => {
         window.location.reload();
       }, 2000);
      return throwError(error)
    }
    if (error.name === "HttpErrorResponse") {
      
      const title = error.error?.title || 'Hata';
      const msg = error.error?.message || error.message || 'Bilinmeyen Hata';
      this.messageService.add({ key: 'tr', severity: 'error', summary: 'Security Error', detail: title + ' ' + msg + ' Login sayfasına yönlendiriliyorsunuz' });

      // LocalStorageService.delEncodedLocalStorageItem();
      // this.router.navigate(['/']);
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);

    }
    //   //
    //   // this.toastrService.error(error.error, "Hata");
    //   if (error.error === "login bilgilerinizde problem tespit edildi lütfen yeniden login olunuz.") {
    //     localStorage.clear();
    //     this.router.navigate(['/auth/login']);

    //   }
    //   if (error.status === 511) {
    //     localStorage.clear();
    //     this.router.navigate(['/auth/login']);

    //   }
    //   localStorage.clear();
    //   this.router.navigate(['/auth/login']);

    //   //  this.router.navigate(['/error/500']);
    //   //     window.location.href=`${environment.loginUrl}`;


    // }
    // this.toastrService.error(error.message, error.statusText);

    return throwError(error)
  }
}
